export default {
  localhost: "AllTest",
  "hfwlcome.com":"com.haoFangPT.Lottery",//浩方平台
  "dsw999.cn":"com.daSheng.Lottery", //叁盛(大圣)
  "binlpc28.cn":"com.binLiGuoJi.Lottery",//宾利国际
  "lafeiapp.cn":"com.laFeiYuLe.Lottery",//拉菲娱乐(拉图国际)
  "app222.fun":"com.lianTuanJiJieDi.Lottery",//联团集结地
  "htwff.fun":"com.hongBoGuoJi.Lottery",//鸿博国际(宏图)
  "app333.fun":"com.LianChengAPP.Lottery",//Lc会所(原联诚APP)
  "access-mvp.cn":"com.qiHangGuoJi.Lottery",//启航国际
  "app000.fun":"com.ruiShiGuoJi.Lottery",//瑞士国际
  "tgszapp.cn":"com.weiYeNa.Lottery",//维也纳
  "app00.fun":"com.shunDa.Lottery",//顺达(丰利)
  // "xsttttc.cn":"com.shunDaCJ.Lottery",//顺达2
  // "sdwee.cn":"com.shunDa.Lottery",//顺达
  // "sdwdd.cn":"com.shunDaCJ.Lottery",//顺达2
  "tmwppp.cn":"com.taiYangGuoJi.Lottery",//太阳国际(TM)
  "hyapp222.cn":"com.hongYunGuoJi.Lottery",//鸿运国际
  "app11.fun":"com.hongSheng.Project",//鸿盛国际(海盛)
  "lianlisz.cn":"com.lianLi28.Project",//联利28(灭盛)
  "pc28lianli.com":"com.lianLi28.Project",//联利28(灭盛)
  "pc28lianli.cn":"com.lianLi28.Project",//联利28(灭盛)
  "uupc28.cn":"com.teYing.Project",//特营
  "mtw00.cn":"com.jingPin.Project",//精品
  "hyapp222.cn":"com.hongShengGuoJi.Project",//鸿盛
  "qapp77.fun":"com.xingJi.Project",//星际
  "appcc.fun":"com.manCheng.Project",//曼城
};



// WEBPACK FOOTER //
// ./src/assets/localPackageConfig.js